import { Status, User } from "../types";
import { getRequestHeaders } from "utils";

export interface UserCredentials {
  email: string;
  password: string;
  clientOS: string;
}

export interface RegisterUserInfo {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  passwordConfirm: string;
  id: number;
  status: Status;
  isNewUser?: boolean;
}

export interface ChangeUserPassword {
  password: string;
  passwordConfirm: string;
  id: number;
  status: Status;
}

export interface UserRegisterResponse extends Response {
  message?: string;
}

export interface GetUserResponse extends Response {
  user?: User;
}

export interface GetUsersResponse extends Response {
  users?: Array<User>;
}

export const postUserLogin = async (
  credentials: UserCredentials,
): Promise<Response> => {
  return await fetch(`${window.USER_BASE_URL}/user/login`, {
    method: "POST",
    ...getRequestHeaders(),
    body: JSON.stringify(credentials),
  });
};

export const completedRegistration = async (
  user: RegisterUserInfo,
  id: number,
  token: string,
  combineAccounts?: boolean,
): Promise<UserRegisterResponse> => {
  return await fetch(
    `${window.USER_BASE_URL}/user/completeRegistration/${id}?combineAccounts=${combineAccounts}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(user),
    },
  );
};

export const postUpdateUserPassword = async (
  user: ChangeUserPassword,
  token: string,
): Promise<Response> => {
  return await fetch(`${window.USER_BASE_URL}/user/resetPassword/${user.id}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(user),
  });
};

export const sendResetPassword = async (email: string): Promise<Response> => {
  return await fetch(`${window.USER_BASE_URL}/user/sendResetPassword`, {
    method: "POST",
    ...getRequestHeaders(),
    body: JSON.stringify({ email }),
  });
};
